<template>
  <div class="ui form">
    <div class="field">
      <label for="searchSavedViews">{{ $tc('SAVED_VIEW', (views && views.length) || 0) }}</label>
      <div class="ui icon input" v-if="views.length > viewPageSize">
        <input
          id="searchSavedViews"
          name="searchSavedViews"
          class="prompt"
          type="text"
          v-model="viewFilter"
          :placeholder="$t('SEARCH')"
        />
        <i class="search icon"></i>
      </div>
    </div>
    <div class="ui basic segment">
      <div class="ui middle aligned selection list">
        <div
          class="item"
          v-for="v in pagedFilteredViews"
          :key="v.id"
          :class="{ active: selectedViewId == v.id }"
          v-on:click="gotoView(v)"
        >
          <div class="content">
            <div class="ui grid">
              <div class="row">
                <div class="twelve wide left floated column" style="line-height: 2em;">
                  <div class="ui mini input" v-if="editingViewId === v.id">
                    <input
                      v-model="editingViewName"
                      type="text"
                      :placeholder="$t('NAME_OF', { thing: $tc('SAVED_VIEW', 1) })"
                    />
                  </div>
                  <template v-else>{{ v.name || v.id }}</template>
                </div>
                <div class="two wide right floated column">
                  <div class="ui right floated secondary mini menu">
                    <div class="ui mini icon buttons">
                      <template v-if="editingViewId === v.id">
                        <div class="ui green button" v-on:click.stop.prevent="saveView(v)">
                          <i class="ui disk icon" />
                        </div>
                        <div class="ui button" v-on:click.stop.prevent="editView(null)">
                          <i class="ui cancel icon" />
                        </div>
                      </template>
                      <div v-else class="ui button" v-on:click.stop.prevent="editView(v)">
                        <i class="edit icon" />
                      </div>

                      <div class="ui red button" v-on:click.stop.prevent="deleteView(v)">
                        <i class="trash icon"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ui left floated secondary mini menu">
      <div class="item">{{ filteredViews.length }}</div>
    </div>
    <div class="ui right floated secondary pagination mini menu">
      <a class="icon item" v-on:click="decrementPagination" v-if="startPagination > 0">
        <i class="left chevron icon"></i>
      </a>
      <a
        class="item"
        v-for="n in Math.min(5, pages)"
        :key="n"
        :class="{ active: viewPage + 1 == startPagination + n }"
        v-on:click="viewPage = startPagination + n - 1"
      >
        {{ startPagination + n }}
      </a>
      <a class="icon item" v-on:click="incrementPagination" v-if="pages > 5">
        <i class="right chevron icon"></i>
      </a>
    </div>
  </div>
</template>

<script>
// @flow
import Vue from 'vue'

export default {
  name: 'saved-views',

  props: {
    views: {
      type: Array,
      default: () => []
    },
    selectedViewId: {
      type: String,
      default: () => null
    }
  },

  data() {
    return {
      viewFilter: '',
      viewPage: 0,
      viewPageSize: 3,
      startPagination: 0,
      editingViewId: null,
      editingViewName: null
    }
  },

  computed: {
    pages() {
      return Math.ceil(this.filteredViews.length / this.viewPageSize)
    },

    pagedFilteredViews() {
      return _.slice(
        this.filteredViews,
        this.viewPage * this.viewPageSize,
        Math.min(this.viewPage * this.viewPageSize + this.viewPageSize, this.filteredViews.length)
      )
    },

    filteredViews() {
      return _.filter(_.sortBy(this.views, 'id'), v => v.name.indexOf(this.viewFilter) >= 0)
    }
  },

  methods: {
    saveView(v) {
      this.$emit('save', { ...v, name: this.editingViewName })
      this.editingViewId = null
    },
    editView(v) {
      if (v == null) {
        this.editingViewId = this.editingViewName = null
      } else {
        this.editingViewId = v.id
        this.editingViewName = v.name
      }
    },

    deleteView(v) {
      this.$emit('delete', v)
    },

    gotoView(v) {
      this.$emit('goto', v)
    },

    incrementPagination() {
      if (this.startPagination + 5 <= this.pages) {
        this.startPagination = Math.min(this.startPagination + 1, this.pages)
      }
    },

    decrementPagination() {
      this.startPagination = Math.max(this.startPagination - 1, 0)
    }
  },

  watch: {
    selectedViewId() {
      // reset any editing
      this.editView(null)
    }
  }
}
</script>
